import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class DestinationForm {
	destination_name:string;
	district : string;
	branch: string;

}

@Injectable()
export class DestinationService {

	private url = environment.url

	constructor(private http: HttpClient) { }


	addNewDestination(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/destination/submit', form, http_options);
	};
	getAllDestination(): Observable<DestinationForm[]> {
		return this.http.get<DestinationForm[]>(this.url + '/masters/destination/all');
	};
	getDestinationFormWith(destination_table_name:string,name:string): Observable<DestinationForm[]> {
		console.log (this.http.get<DestinationForm[]>(this.url + '/masters/destination/get/' + name));
		return this.http.get<DestinationForm[]>(this.url + '/masters/destination/get/'+destination_table_name +'/'+ name);
	};
	getDestinationFormWithBranch(branch:string): Observable<DestinationForm[]> {
		return this.http.get<DestinationForm[]>(this.url + '/masters/destination/get/branch/' + branch);
	};
	getDestinationFormWithClientAndBranch(destination_table_name:string): Observable<DestinationForm[]> {
		return this.http.get<DestinationForm[]>(this.url + '/masters/destination/get/branchandclient/'+ destination_table_name);
	};
}




// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/_services/_masters/destination.service.ts